import Venue from "../pages/Event/Venue/Venue";
import apiClient from "./apiClient";
import { StripeAccountStatusResponse } from "../types/StripeAccountStatusResponse";


/** Events Section */
/**
 * Fetches all events.
 * @param {number} id - The user ID.
 * @returns {Promise<Object>} - The user object.
 */
export const getAllEvents = async () => {
    const response = await apiClient.get(`/events`);
    return response.data;
};

export const getEventBySlug = async (slugId) => {
    const response = await apiClient.get(`/events/${slugId}`);
    return response.data;
};

export const getEventById = async (id) => {
    const response = await apiClient.get(`/events/event-by-id/${id}`);
    return response.data;
};


/** Ticket Section */

/**
 * Fetches all tickets by slug.
 * @param {string} slug - The user ID.
 * @returns {Promise<Object>} - The user object.
 */

export const getAllTicketsBySlug = async (slug) => {
    const response = await apiClient.get(`/ticket-type/${slug}`);
    return response.data;
};


/** Booking  Section */

export const createBooking = async (data) => {
    const response = await apiClient.post('/booking', data);
    return response.data;
};


export const getBookingPayment = async (bookingNo) => {
    const response = await apiClient.get(`/booking/payment/${bookingNo}`);
    return response.data;
}

export const getBookingDetails = async (bookingNo) => {
    const response = await apiClient.get(`/booking/${bookingNo}`);
    return response.data;
}

export const sendEmailConfirmation = async (bookingNo) => {
    const response = await apiClient.get(`/booking/send-confirmation/${bookingNo}`);
    return response.data;
}

export const updateBookingConfirmation = async (bookingId,data) => {
    const response = await apiClient.put(`/booking/${bookingId}`,data);
    return response.data;
}

export const refundBookingByBookingNo = async (bookingNo, data = {}) => {
    const response = await apiClient.post(`/booking/${bookingNo}/refund`, data);
    return response.data;
}



//Admin API

export const getAllEventByOrganizer = async () => { 
    const response = await apiClient.get(`/events/organizer`);
    return response.data;
}

export const getEventListByOrganizer = async () => {
    const response = await apiClient.get('/events/organizer/revenue');
    return response.data;
}

export const getAllBookingByEvent = async (slugId) => {
    const response = await apiClient.get(`/booking/event/${slugId}`);
    return response.data;
}
export const getAllBookingByOrganizer = async () => {
    const response = await apiClient.get(`/booking/organizer`);
    return response.data;
}

//Auth
export const userLogin = async (data) => {
    
    const response = await apiClient.post('/auth/login', data);
    return response.data;
   
};
export const organizerBypassLogin = async (data) => {
    
    const response = await apiClient.post('/auth/organizer-bypass-login', data);
    return response.data;
   
};
export const loginRequestOTP = async (data) => {
    const response = await apiClient.post('/v2/users/login/request-otp', data);
    return response.data;
};
export const loginVerifyOTP = async (data) => {
    const response = await apiClient.post('/v2/users/login/verify-otp', data);
    return response.data;
};

//get organizer profile
export const getOrganizerProfile = async () => {
    const response = await apiClient.get('/organizer/profile');
    return response.data;
};
// Get all categories
export const getAllCategories = async () => {
    const response = await apiClient.get('/categories');
    return response.data;
};

// Get all countries
export const getAllCountries = async () => {
    const response = await apiClient.get('/countries');
    return response.data;
};
//get all organizer events
export const getAllOrganizerEvents = async () => {
    const response = await apiClient.get('/events/organizer');
    return response.data;
};
export const getAllEventsByOrganizerId = async (organizerId) => {
    const response = await apiClient.get(`/organizer/${organizerId}/with-events`);
    return response.data;
};
//create event
export const createEvent = async (data) => {
    const response = await apiClient.post('/events/ ',data);
    return response.data;
}
// create event api 
export const createOrganizerEvent = async (data) => {
    const response = await apiClient.post('/events/organizer', data);
    return response.data;
};
//update event api
export const updateEvent = async (id,data) => {
    const response = await apiClient.put(`/events/${id}`, data);
    return response.data;
};
//delete event 
export const deleteEvent = async (slugId) => {
    const response = await apiClient.delete(`/events/${slugId}`);
    return response.data;
};
//get all ticket group by slug
export const getAllTicketGroupBySlug = async (slug) => {
    const response = await apiClient.get(`/ticket-group/${slug}`);
    return response.data;
};
//create ticket group
export const createTicketGroup = async (data) => {
    const response = await apiClient.post('/ticket-group',data);
    return response.data;
}
//delete ticket group
export const deleteTicketGroup = async (slugId) => {    
    const response = await apiClient.delete(`/ticket-group/${slugId}`);
    return response.data;
}
//update ticket group
export const updateTicketGroup = async (id,data) => {
    const response = await apiClient.patch(`/ticket-group/${id}`,data);
    return response.data;
}
//get all ticket by slug 
export const getAllTicketBySlug = async (slug) => {
    const response = await apiClient.get(`/ticket-type/${slug}`);
    return response.data;
};
export const getAllTicketBySlugV2 = async (slug) => {
    const response = await apiClient.get(`/v2/ticket-type/${slug}`);
    return response.data;
};
export const deleteTicket = async (id) => {
    const response = await apiClient.delete(`/ticket-type/${id}`);
    return response.data;
};
//venue 
export const createVenue = async (data) => {
    const response = await apiClient.post('/event-venue', data);
    return response.data;
};
export const getAllVenueBySlug = async (slug) => {
    const response = await apiClient.get(`/event-venue/${slug}`);
    return response.data;
};
export const updateEventVenue = async (id,data) => {
    const response = await apiClient.put(`/event-venue/${id}`,data);
    return response.data;
}
//delete event venue
export const deleteVenue = async (slugId) => {
    const response = await apiClient.delete(`/event-venue/${slugId}`);
    return response.data;
}
//create ticket api
export const createTicket = async (data) => {
    const response = await apiClient.post('/ticket-type', data);
    return response.data;
};
//update ticket api'
export const updateTicket = async (id,data) => {
    const response = await apiClient.put(`/ticket-type/${id}`, data);
    return response.data;
};
//organizer contact list
export const organizerContactList = async (OrganizerId) => {
    const response = await apiClient.get(`/contacts/organizer/${OrganizerId}`, );
    return response.data;
};
//Report
export const getReport = async (id) => {
    const response = await apiClient.get(`/booking/booking-by-event/${id}`, );
    return response.data;
};
/** All events revenue rollup (confirmed primary bookings). Optional: organizerId, eventId, eventStatus, limit, offset */
export const getEventDetailedRevenueReport = async (params = {}) => {
    const query = new URLSearchParams();
    if (params.organizerId != null && String(params.organizerId).trim() !== "") {
        query.append("organizerId", String(params.organizerId).trim());
    }
    if (params.eventId != null && String(params.eventId).trim() !== "") {
        query.append("eventId", String(params.eventId).trim());
    }
    if (params.eventStatus != null && String(params.eventStatus).trim() !== "") {
        query.append("eventStatus", String(params.eventStatus).trim());
    }
    if (params.limit != null && String(params.limit).trim() !== "") {
        query.append("limit", String(params.limit).trim());
    }
    if (params.offset != null && String(params.offset).trim() !== "") {
        query.append("offset", String(params.offset).trim());
    }
    const qs = query.toString();
    const url = `/v2/event/event-detailed-revenu-report${qs ? `?${qs}` : ""}`;
    const response = await apiClient.get(url);
    return response.data;
};
//coupon
export const getCoupon = async (eventId) => {
    const response = await apiClient.get(`/coupon/${eventId}`, );
    return response.data;
};
//get all coupon by organizer
export const getAllCoupon = async () => {
    const response = await apiClient.get('/coupon');
    return response.data;
}
//create organizer coupon
export const createOrganizerCoupon = async (data) => {
    const response = await apiClient.post('/coupon/organizer',data);
    return response.data;
}
//update organizer coupon
export const updateOrganizerCoupon = async (id,data) => {
    const response = await apiClient.put(`/coupon/${id}`,data);
    return response.data;
}
//delete organizer coupon
export const deleteCoupon = async (slugId) => {
    const response = await apiClient.delete(`/coupon/${slugId}`); 
    return response.data;
}
export const getPromoters = async () => {
    const response = await apiClient.get('/promoters');
    return response.data;
};
export const createPromoter = async (data) => {
    const response = await apiClient.post('/promoters', data);
    return response.data;
};
export const updatePromoter = async (id, data) => {
    const response = await apiClient.put(`/promoters/${id}`, data);
    return response.data;
};
export const deletePromoter = async (id) => {
    const response = await apiClient.delete(`/promoters/${id}`);
    return response.data;
};
export const getOrganizerPromoterEarnings = async () => {
    const response = await apiClient.get('/promoter-earnings/organizer');
    return response.data;
};
export const getTicketTypeBySlug = async (slugId) => {
    const response = await apiClient.get(`/ticket-type/${slugId}`, );
    return response.data;
};
export const getSponsorList = async () => {
    const response = await apiClient.get('/sponsor');
    return response.data;
}

export const getSponsorByEventSlug = async (slugId) => {
    const response = await apiClient.get(`/sponsor/event/${slugId}`);
    return response.data;
}
//get all sponsor types
export const getAllSponsorTypes = async () => {
    const response = await apiClient.get(`/sponsor-type`);
    return response.data;
}
export const updateSponsor = async (id,data) => {
    const response = await apiClient.put(`/sponsor/${id}`,data);
    return response.data;
}
//delete sponsor
export const deleteSponsor = async (slugId) => {
    const response = await apiClient.delete(`/sponsor/${slugId}`);
    return response.data;
}
//create sponsor
export const createSponsor = async (data) => {
    const response = await apiClient.post(`/sponsor`, data);
    return response.data;
}
// booking slot
export const getBookingSlot = async (slugId) =>{
    const response = await apiClient.get(`/booking-slot/slug/${slugId}`);
    return response.data;
}
export const updateBookingSlot = async (id,data) => {
    const response = await apiClient.put(`/booking-slot/${id}`,data);
    return response.data;
}
export const deleteBookingSlot = async (id) => {
    const response = await apiClient.delete(`/booking-slot/${id}`);
    return response.data;
}
export const createBookingSlot = async (data) => {
    const response = await apiClient.post('/booking-slot', data);
    return response.data;
}
// user
export const createUser = async (id,data) => {
    const response = await apiClient.post(`/users/organizer/${id}/user`, data);
    return response.data;
}
export const getUser = async (id) =>{
    const response = await apiClient.get(`/users/organizer/${id}/users`);
    return response.data;
}
export const updateUser = async (organizerId, data) => {
    const response = await apiClient.put(`/users/organizer/user/${organizerId}`, data);
    return response.data;   
} 
export const deleteUser = async (id) => {
    const response = await apiClient.delete(`/users/organizer/user/${id}`);
    return response.data;
}
export const getUserByEmail = async (email) => {
    const response = await apiClient.get(`/users/email/${email}`);
    return response.data;
}
//Agenda
export const  getAgendaByOrganizer = async () =>{
    const response = await apiClient.get(`/agenda/organizer`);
    return response.data;
}
export const createAgenda = async (data) =>{
    const response = await apiClient.post(`/agenda` , data);
    return response.data;
}
export const updateAgenda = async (agendaId, data) => {
    const response = await apiClient.put(`/agenda/${agendaId}`, data);
    return response.data;   
} 
export const deleteAgenda = async (id) => {
    const response = await apiClient.delete(`/agenda/${id}`);
    return response.data;
}

// Create new lineup (with image upload)
export const createLineup = async (data) => {
    const response = await apiClient.post(`/lineup`, data);
    return response.data;
};

// Get all lineups for the authenticated organizer
export const getLineupsByOrganizer = async () => {
    const response = await apiClient.get(`/lineup/organizer`);
    return response.data;
};

// Update a lineup by ID (with image upload)
export const updateLineup = async (id, data) => {
    const response = await apiClient.put(`/lineup/${id}`,data);
    return response.data;
};

// Delete a lineup (soft delete)
export const deleteLineup = async (id) => {
    const response = await apiClient.delete(`/lineup/${id}`);
    return response.data;
};

//contact
// const API_BASE_URL = "https://apiqa.eventox.co/api/contacts/organizer/${OrganizerId}"; 
// export const getContactsByEvent = async (eventSlug) => {
//     try {
//         const response = await axios.get(${API_BASE_URL}?event=${eventSlug});
//         return response.data; 
//     } catch (error) {
//         console.error("Error fetching contacts:", error);
//         throw error;
//     }
// };


// password apis

export const checkOldPassword = async (userId, oldPassword) => {
    const response = await apiClient.post('/users/check-password', {
        userId,
        oldPassword,
    });
    return response.data;
};

export const changePassword = async (
    userId,
    oldPassword,
    newPassword
) => {
    const response = await apiClient.post('/users/change-password', {
        userId,
        oldPassword,
        newPassword,
    });
    return response.data;
};

export const forgotPassword = async (email) => {
  const response = await apiClient.post('/users/forgot-password', { email });
  return response.data;
};

export const resetPassword = async (token, newPassword) => {
  const response = await apiClient.post('/users/reset-password', {
    token,
    newPassword,
  });
  return response.data;
};
// register organizer
export const requestOTP = async (data) => {
    const response = await apiClient.post('/v2/users/signup/request-otp', data);
    return response.data;
};
export const verifyOTP = async (data) => {
    const response = await apiClient.post('/v2/users/signup/verify-otp', data);
    return response.data;
};
export const registerOrganizer = async (data) => {
    const response = await apiClient.post('/v2/users/signup/complete', data);
    return response.data;
};
export const updateOrganizer = async (organizerId,data) => {
    const response = await apiClient.patch(`/v2/organizers/${organizerId}`,data);
    return response.data;
};
// change password v2
export const changePasswordVerifyOtp = async (data) => {
    const response = await apiClient.post('/v2/users/password-change/verify-otp',data);
    return response.data;
};
export const changePasswordRequestOtp = async () => {
    const response = await apiClient.post('/v2/users/password-change/request-otp',);
    return response.data;
};
export const changePasswordCompleteOtp = async (data) => {
    const response = await apiClient.post('/v2/users/password-change/complete',data);
    return response.data;
};




// Comprehensive booking search API
export const searchBookings = async (searchParams) => {
    try {
        const response = await apiClient.get('/booking/search', {
            params: searchParams
        });
        return response.data;
    } catch (error) {
        console.error("Error searching bookings:", error);
        throw error;
    }
};

export const getAllBookingByDateRange = async (from, to) => {
    const response = await apiClient.get(`/v2/search/date-wise-eventox-revenue`, {
      params: { from, to },
    });
    return response.data;
  };


// Search bookings by email or phone
export const searchBookingsByContact = async (searchTerm) => {
    try {
        const response = await apiClient.get('/v2/search/search-contact', {
            params: { searchTerm }
        });
        return response.data;
    } catch (error) {
        console.error("Error searching bookings by contact:", error);
        throw error;
    }
};

// Get all bookings with filters
export const getAllBookingsWithFilters = async (filters = {}) => {
    try {
        const response = await apiClient.get('/booking/all-with-filters', {
            params: filters
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching bookings with filters:", error);
        throw error;
    }
};

//create event draft 
export const createEventDraft = async (data) => {
    try {
        const response = await apiClient.post('/v2/event-drafts', data);
        return response.data;
    } catch (error) {
        console.error("Error creating event draft:", error);
        throw error;
    }
   
}
//create quick event
export const createQuickEventV2 = async (data) => {
    const response = await apiClient.post('/v2/event', data);
    return response.data;
}
// Get forum details by slug ID
export const getForumBySlug = async (slugId) => {
    try {
        // Make GET request to fetch forum details for given slug ID
        const response = await apiClient.get(`/form/forms/${slugId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching forum details:", error);
        throw error;
    }
};


export const getEventDraftById = async (id) => {
    const response = await apiClient.get(`/v2/event/${id}`);
    return response.data;
}

export const getAllDraftEvent = async () => {
    const response = await apiClient.get(`/v2/event-drafts`);
    return response.data;
}

export const updateEventBySlug = async (slugId, data) => {
  const response = await apiClient.put(`/v2/event/slug/${slugId}`, data);
  return response.data;
};

export const activateEventBySlug = async (slugId) => {
  const response = await apiClient.patch(`/v2/event/slug/${slugId}/status/active`);
  return response.data;
};

// Stripe onboarding APIs
/**
 * Creates a Stripe Express account for the organizer
 * @returns {Promise<Object>} - Returns { accountId: string }
 */
export const stripeOnboarding = async () => {
    const response = await apiClient.post('/organizer/stripe/onboarding');
    return response.data;
};

/**
 * Creates an account link for Stripe onboarding
 * @param {string} accountId - The Stripe account ID
 * @returns {Promise<Object>} - Returns { link: string } - The Stripe onboarding URL
 */
export const stripeAccountLink = async (accountId) => {
    const response = await apiClient.post('/organizer/stripe/account/link', { accountId });
    return response.data;
};

/**
 * Retrieves Stripe account status
 * @returns {Promise<Object>} - Returns account status with details_submitted and charges_enabled
 */
export const getStripeAccountStatus = async () => {
    const response = await apiClient.get('/organizer/stripe/account/status');
    return response.data;
};


//Entitlements
export const getEntitlementsByKey = async (key) => {
    const response = await apiClient.get(`/entitlements/key/${key}`);
    return response.data;
}

/**
 * Checks if an organizer has access to a premium entitlement
 * @param {number} organizerId - The ID of the organizer to check
 * @param {string} entitlementKey - The key of the entitlement to check
 * @returns {Promise<Object>} - Response with hasAccess, message, and data
 */
export const checkPremiumEntitlementAccess = async (organizerId, entitlementKey) => {
    const response = await apiClient.get(`/entitlements/check-premium-access`, {
        params: {
            organizerId,
            entitlementKey
        }
    });
    return response.data;
}

// Download ticket - responseType 'blob' is required for binary PDF data
export const downloadTicketByBookingNo = async (bookingNo) => {
    const response = await apiClient.get(`/v2/booking/download-ticket/${bookingNo}`, {
        responseType: 'blob'
    });
    return response.data;
}
// Discover API
export const createDiscover = async (data) => {
    const response = await apiClient.post('/discover', data);
    return response.data;
};
export const getAllDiscovers = async () => {
    const response = await apiClient.get('/discover');
    return response.data;
};
export const getDiscoverById = async (id) => {
    const response = await apiClient.get(`/discover/${id}`);
    return response.data;
};
export const updateDiscover = async (id, data) => {
    const response = await apiClient.put(`/discover/${id}`, data);
    return response.data;
};
export const deleteDiscover = async (id) => {
    const response = await apiClient.delete(`/discover/${id}`);
    return response.data;
};
export const getDiscoverByReference = async (refId, referenceType, page = 1, limit = 20) => {
    try {
        const response = await apiClient.get(`/discover/by-reference?referenceId=${refId}&referenceType=${referenceType}&page=${page}&limit=${limit}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching discover by reference:", error);
        throw error;
    }
};

export const createBankDetails = async (data) => {
    const response = await apiClient.post('/bank-details', data);
    return response.data;
};

export const getAllBankDetails = async () => {
    const response = await apiClient.get('/bank-details');
    return response.data;
};

export const getBankDetailsByOrganizer = async (organizerId) => {
    const response = await apiClient.get(`/bank-details/organizer/${organizerId}`);
    return response.data;
};

export const getBankDetailsById = async (id) => {
    const response = await apiClient.get(`/bank-details/${id}`);
    return response.data;
};

export const updateBankDetails = async (id, data) => {
    const response = await apiClient.put(`/bank-details/${id}`, data);
    return response.data;
};

export const deleteBankDetails = async (id) => {
    const response = await apiClient.delete(`/bank-details/${id}`);
    return response.data;
};

export const createPayoutRequest = async (data) => {
    const response = await apiClient.post('/payouts', data);
    return response.data;
};

export const getPayoutsByOrganizer = async (organizerId) => {
    const response = await apiClient.get(`/payouts/organizer/${organizerId}`);
    return response.data;
};

export const cancelPayoutRequest = async (payoutId, organizerId) => {
    const response = await apiClient.patch(`/payouts/${payoutId}/cancel`, { organizerId });
    return response.data;
};

/** Eventox AI organizer assistant chat */
export const sendAiChat = async (payload) => {
    const response = await apiClient.post('/ai/chat', payload);
    return response.data;
};

/** Confirm a pending Ask Ev event edit */
export const confirmAiEdit = async (payload) => {
    const response = await apiClient.post('/ai/confirm-edit', payload);
    return response.data;
};

/** Cancel a pending Ask Ev event edit */
export const cancelAiEdit = async (payload) => {
    const response = await apiClient.post('/ai/cancel-edit', payload);
    return response.data;
};
